#import "../fragments/contact-basic.graphql"

query GetContactsSearchResults($query: String, $limit: Int) {
    search(query: $query, type: CONTACT, limit: $limit) {
        quickResults {
            recentResults {
                ... on Lead {
                    id
                    name
                }
                ... on Account {
                    id
                    name
                }
                ... on Contact {
                    ...ContactBasic
                }
            }
            contactResults {
                ...ContactBasic
            }
        }
    }
}
